// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/building-2.js';

import { paths } from '../generated/building-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('building-2', Original, paths);
